import {WlBrandedButton} from "./button.component";

export * from './button.component';
export default WlBrandedButton;

export const BUTTON_TAG = 'wl-branded-button';
customElements.define(BUTTON_TAG, WlBrandedButton);